import debug from 'debug';
import InlineView from 'Minetilbud/Shared/Components/inline-view/inline-view';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Behaviour from '../customer-page-feed/static/behaviour';

const log = debug('Footer');
const debounce = new Debounce().debounce;

class Footer extends BaseComponent {
	constructor(element) {
		super(element);

		this.hasNoProductsEvent = this.hasNoProductsHandler.bind(this);
		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);

		this.initialize();
	}

	eventListeners() {
		document.addEventListener('scroll', this.scrollEvent, true);
		document.addEventListener(Behaviour.eventKeys.hasNoProducts, this.hasNoProductsEvent, false);
	}

	hasNoProductsHandler() {
		this.setup();
	}

	initialize() {
		this.initDomCache();
		this.setup();
		this.eventListeners();
	}

	/**
	 * @returns {boolean}
	 */
	isInView() {
		const elementRect = this.element.getBoundingClientRect();
		return elementRect.top > 0 && elementRect.top < window.innerHeight;
	}

	scrollHandler() {
		this.setup();
	}

	setup() {
		if (InlineView.isEnabled()) {
			this.element.classList.add('is-inline-view');
		} else {
			this.element.classList.remove('is-inline-view');
		}

		if (this.isInView() === false) return;

		this.element.classList.add('is-visible');
	}

}

export default Footer;
